$(function () {
  'use strict';
  
  $('.menu-details_accordion-header').on('click', function () {
    if ($(this).parent().hasClass('opened')) {
      $(this).parent().removeClass('opened');
    } else {
      $(this).parent().addClass('opened');
    }
  });
})